(($) => {
  const $equalHeightContainer = $(".equal-height-container");
  const windowWidthThreshold = 991;

  // Early return if no equal-height containers are found
  if (!$equalHeightContainer.length) return;

  // Immediately apply equal heights to children without an initial delay
  applyEqualHeightToChildren();

  // Function to handle window resize with debounced callback
  function handleResizeWithDebounce() {
    let resizeTimeout;

    const debounceResize = Drupal.debounce(() => {
      clearTimeout(resizeTimeout);
      // Reduced debounce time to 250 milliseconds
      resizeTimeout = setTimeout(applyEqualHeightToChildren, 250);
    });

    // Attach the debounce function to the window resize event if condition is met
    if ($(window).width() > windowWidthThreshold) {
      $(window).on("resize", debounceResize);
    }
  }

  // Execute the resize handler setup function
  handleResizeWithDebounce();

  // Function to apply equal height to all children of each '.equal-height-container'
  function applyEqualHeightToChildren() {
    $equalHeightContainer.each(function () {
      const $container = $(this); // Cache the current container jQuery object
      const images = $container.find('img'); // Find all images within the container
      let imagesLoaded = 0; // Counter for loaded images

      // Function to adjust the heights of container children
      const adjustHeights = () => {
        const heights = []; // Array to store the maximum heights of children
        // Get the target child selector from data attribute or default to direct children
        let target = $container.data("equal-height-target") || "";

        // Iterate over each child element of the container
        $container.children().each((_, elem) => {
          // Find the elements to apply equal height based on the target selector
          const $columns = target ? $(elem).find(target).children() : $(elem).children();

          // Calculate the maximum height of elements and store in the heights array
          $columns.each((index, field) => {
            $(field).height("initial");
            const currentHeight = $(field).height();
            heights[index] = Math.max(heights[index] || 0, currentHeight);
          });
        });

        // Apply the maximum height found to each child element
        $container.children().each((_, elem) => {
          const $columns = target ? $(elem).find(target).children() : $(elem).children();
          $columns.each((index, field) => $(field).height(heights[index]));
        });
      };

      // Handle image loading within the container
      if (images.length) {
        // Bind load event to each image and adjust heights once all images are loaded
        images.on('load', () => {
          if (++imagesLoaded === images.length) adjustHeights();
        }).each(function () {
          // Trigger load event if the image is already loaded (cached)
          if (this.complete) $(this).trigger('load');
        });
      } else {
        // If there are no images, adjust heights immediately
        adjustHeights();
      }
    });
  }
})(jQuery);
